module.exports = __webpack_public_path__ + "static/media/homeImage.bbe610bf.png";